import { useEffect, useState } from 'react'

import { conversationSelector, useStore } from '@liveHelper/models/store'
import { useSocketContext } from '@oneToOne/shared/contexts/SocketContext'

import { logMessage, safeLogVariable } from '@core/logging/helpers'
import { getGuestId } from '@core/tracking/guestId'

/** @returns The topic for the oneToOne visitor channel */
export const useVisitorTopic = () => {
  const guestId = getGuestId()
  const conversation = useStore(conversationSelector)

  const { recreateSocket, urlParams } = useSocketContext()
  const chatChannelId = urlParams?.chat_channel_id

  const [topic, setTopic] = useState(
    chatChannelId ? `oto:visitor:private:${chatChannelId}:${guestId}` : '',
  )

  // There are instances where the guestId changes between the time the socket is created and the time the channel is joined.
  // Hence, we need to recreate the socket with the new guestId.
  useEffect(() => {
    if (urlParams?.visitor_id !== guestId && !conversation) {
      logMessage('Visitor id mismatch', {
        captureContext: {
          extra: {
            urlParams: safeLogVariable(urlParams),
            guestId: guestId,
          },
        },
      })

      setTopic(
        chatChannelId ? `oto:visitor:private:${chatChannelId}:${guestId}` : '',
      )
      recreateSocket?.({ ...urlParams, visitor_id: guestId })
    }
  }, [guestId, urlParams, recreateSocket, chatChannelId, conversation])

  return topic
}
